import React from "react";
import { GlobalApplicationState } from "globalApplicationState";
import { useDispatch, useSelector } from "react-redux";

import { setMainStyle, setShouldDisplayNav } from "modules/adminLayout/actionCreator"

export const useDisplayNav = (expectedNavStatus: boolean, backgroundStyle?: React.CSSProperties) => {
    const dispatch = useDispatch();

    //True = open
    const currentNavStatus = useSelector((state: GlobalApplicationState) => state.adminLayout.shouldDisplayNav);

    if(expectedNavStatus !== currentNavStatus) {
        dispatch(setShouldDisplayNav(expectedNavStatus));
        dispatch(setMainStyle(backgroundStyle));
    }
}